/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceAccountQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountQueryOperator>): ServiceAccountQueryOperator {
        let obj = Object.assign(new ServiceAccountQueryOperator(), model);
        ServiceAccountQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountQueryOperator>): ServiceAccountQueryOperator {
        if (!model) return null;
        return ServiceAccountQueryOperator.newInstance(<ServiceAccountQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountQueryOperator) {
        if (!obj) return;

        models.ServiceAccountQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Accounts to include
     */
    service_account_ids: Array<string>;

}
